import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  search: generateApiPath({ prefix: AuthLevel.AUTH, name: 'search' }),
}

export { paths }
